import { get, post, put } from "./apiClient";
import { uriWithQueryStringParams } from "../utils/urlUtils";
import { filter } from "lodash";

export default {
  async getJobRolesByCustomerId(customerId) {
    return await get(uriWithQueryStringParams("ImsJobRole", { customerId }));
  },

  async getActiveJobRolesByCustomerId(customerId) {
    return filter(
      await this.getJobRolesByCustomerId(customerId),
      (c) => c.isActive
    );
  },

  async setActiveStatus(jobRole) {
    return await put("ImsJobRole/ActiveStatus", jobRole);
  },

  async saveJobRole(jobRole) {
    return await post("ImsJobRole", jobRole);
  },

  async getJobRoleTypes(customerId) {
    return await get(
      uriWithQueryStringParams("ImsJobRole/Types", { customerId })
    );
  }
};
